// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInResetPasswordFormStyles } from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

signInResetPasswordFormStyles.buttonsGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        ${xScreen("lte", "xs")} {
            flex-direction: column-reverse;
            & > button {
                width: 100%;
            }
        }
    `,
};

signInResetPasswordFormStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
        ${xScreen("lte", "xs")} {
            margin-right: 0;
            margin-top: 20px;
        }
    `,
};
